'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { SignIn } from '@/components/Signin/SignIn';
import { SelectOptions } from '@/components/Signin/types';
type Envs = {
  backendApiUrl: string;
  enabledAzure: boolean;
  enabledLDAP: boolean;
  enabledKUA: boolean;
  azureAdProviderId: string;
  enabledAccessRequest: boolean;
};
export function LoginClient(t0) {
  const $ = _c(12);
  const {
    envs
  } = t0;
  const requestEndpoint = envs.backendApiUrl + "/api/request-access";
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      rigs: [],
      applications: []
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [requestDataOptions, setRequestDataOptions] = useState(t1);
  let t2;
  if ($[1] !== envs.backendApiUrl) {
    t2 = () => {
      (async () => {
        const response = await fetch(envs.backendApiUrl + "/api/request-data");
        if (response.ok) {
          const data = await response.json();
          setRequestDataOptions(data);
        }
      })();
    };
    $[1] = envs.backendApiUrl;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = [];
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  if ($[4] !== envs.azureAdProviderId || $[5] !== envs.enabledAccessRequest || $[6] !== envs.enabledAzure || $[7] !== envs.enabledKUA || $[8] !== envs.enabledLDAP || $[9] !== requestDataOptions || $[10] !== requestEndpoint) {
    t4 = <SignIn enabledAzure={envs.enabledAzure} enabledLDAP={envs.enabledLDAP} enabledKUA={envs.enabledKUA} requestEndpoint={requestEndpoint} requestDataOptions={requestDataOptions} azureAdProviderId={envs.azureAdProviderId} requestAccessEnabled={envs.enabledAccessRequest} />;
    $[4] = envs.azureAdProviderId;
    $[5] = envs.enabledAccessRequest;
    $[6] = envs.enabledAzure;
    $[7] = envs.enabledKUA;
    $[8] = envs.enabledLDAP;
    $[9] = requestDataOptions;
    $[10] = requestEndpoint;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
}